export default __webpack_public_path__ + "static/media/09d.189172b9.jpg";